/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SORTABLE : ITEM
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	sortableitem: {
		height: pxToEm(55),
		width: '100%', //pxToEm(650),
		display: 'inline-flex',
		alignItems: 'center',
		margin: `${pxToEm(5)}`,
		padding: `${pxToEm(15)}`,
		backgroundColor: theme.color.light.light.swatch,
		border: `${pxToEm(1)} solid #ECF0F7`,
		borderRadius: '5px',
		boxShadow: `0px 1px 1px 0px #EDF1FA`,
		'& .drag-icon': {
			opacity: '0.5'
		},
		'& .single-item-list': {
			marginLeft: `${pxToEm(16)}`
		}
	}
});